<template>
  <div class="login-main">
    <img class="background-img" :src="backSrc" alt="" />

    <div class="login-container">
      <img class="logo" :src="logo" alt="" />
      <Input
        class="logged-in-list"
        v-if="!selectedLoggedInUser"
        textAlign="center"
        placeholder="Email"
        :inputValue.sync="userEmail"
        :isDisabled="useridDisable"
        @keyup="inputEnter($event, 'continue')"
        ref="userIdInput"
      />

      <div :class="otherDetailsClass">
        <Dropdown
          placeholder="Company"
          :isDisabled="showChangePass || isLoggedIn"
          style="margin-top: 8px"
          textAlign="center"
          :items="companyList"
          itemKey="showValue"
          :selectedObject.sync="selectedCompany"
          @selected="companySelected"
          :search.sync="companySearch"
          ref="companyDropdown"
        />
        <div v-if="loginUserId" class="user-id">User ID : {{ loginUserId }}</div>

        <Input
          textAlign="center"
          placeholder="Password"
          :inputValue.sync="password"
          textType="password"
          :isDisabled="!selectedCompany || branchList.length > 0"
          ref="userPassInput"
          @keyup="inputEnter($event, '')"
        />
      </div>

      <div class="error">{{ errorMessage }}</div>

      <div class="btn-block">
        <button v-if="!showLoginBtn" @click="btnClick(selectedLoggedInUser ? 'loginUser' : 'continue')">{{
          selectedLoggedInUser ? `Log In as ${selectedLoggedInUser['user']}` : 'Continue'
        }}</button>
        <div v-else>
          <button class="btn btn-alert" @click="btnClick('back')">Back</button>
          <button :disabled="showChangePass || isLoggedIn" class="btn" @click="btnClick('login')">Login</button>
        </div>
      </div>

      <Dropdown
        placeholder="Branch"
        style="margin-top: 38px"
        v-if="branchList.length > 0"
        textAlign="center"
        :items="branchList"
        itemKey="BrCode"
        @selected="branchSelected"
        :selectedObject.sync="selectedBranch"
        ref="branchDropdown"
      />
      <Dropdown
        placeholder="Base"
        style="margin: 8px 0"
        v-if="baseList.length > 0"
        textAlign="center"
        :items="baseList"
        @selected="baseSelected"
        itemKey="baseKey"
        :selectedObject.sync="selectedBase"
        ref="baseDropdown"
      />
      <button class="btn" @click="nextClick" v-if="selectedBranch && selectedBase" ref="nextBtn">Next</button>

      <div v-if="showChangePass" class="change-password">
        <Input
          :inputValue.sync="updatePassword1"
          textType="password"
          placeholder="Enter new password"
          textAlign="center"
          ref="newPass1"
          @enter="$refs.newPass2.setFocus()"
        />
        <Input
          :inputValue.sync="updatePassword2"
          textType="password"
          placeholder="Re-enter new password"
          textAlign="center"
          @enter="updateClick()"
          ref="newPass2"
        />
        <div class="error" style="margin-bottom: 10px">{{ updatePassError }}</div>
        <button @click="updateClick">Submit</button>
      </div>
    </div>

    <Loader :isVisible="loading" :loadingText="loadText" :isFullScreen="true" />

    <div class="footer">
      <img src="https://dsmapi.logistics.systems/logo/dsm.gif" alt="" />
      <div>Copyright &copy; {{ new Date().getFullYear() }}</div>
      <div>Digital Systems (M) Sdn Bhd All Rights Reserved</div>
      <div>Version {{ $store.state['versions'].length > 0 ? $store.state['versions'][0]['Version'] : '' }}</div>
    </div>

    <PopupV2
      :show="showUserList"
      :buttons="[{ text: 'New Account', color: 'gray', textColor: 'white' }]"
      @buttonClicked="
        showUserList = false;
        $refs.userIdInput.setFocus();
      "
      title="Logged In Accounts"
      :backgroundCancel="true"
      :isFullScreen="true"
    >
      <div class="loggedin-list-container">
        <div v-if="loginDetailsList.length > 0"
          >You have logged into {{ loginDetailsList.length }} account{{ loginDetailsList.length > 1 ? 's' : '' }}</div
        >
        <div v-if="loginDetailsList.length > 0"
          >Please choose one from the logged in account below to login, or click 'New Account' to login to a new
          account</div
        >
        <div v-if="loginDetailsList.length > 0" class="logged-in-container-body">
          <div
            class="loggedin-list-content"
            v-for="(l, i) in loginDetailsList"
            :key="i"
            @click="loggedInAccountClicked(l['key'])"
          >
            <div class="loggedin-list-details">
              <div class="loggedin-list-row">
                <div>User ID</div>
                <div>:</div>
                <div>{{ l['LoginUserId'] }}</div>
              </div>
              <div class="loggedin-list-row">
                <div>Company</div>
                <div>:</div>
                <div>{{ l['CoName'] }}</div>
              </div>
              <div class="loggedin-list-row">
                <div>Branch</div>
                <div>:</div>
                <div>{{ l['Branch']['BrCode'] }}</div>
              </div>
              <div class="loggedin-list-row">
                <div>Base</div>
                <div>:</div>
                <div>{{ l['BaseName'] }}</div>
              </div>
              <div class="loggedin-list-row">
                <div>Logged In At</div>
                <div>:</div>
                <div>{{ new Date(l['LoginTime']).formatString('yyyy-MM-dd HH:mm:ss') }}</div>
              </div>
            </div>
            <button style="background-color: red; color: white" @click="loggedinListLogoutClicked($event, l['key'], l)"
              >Logout</button
            >
          </div>
        </div>
        <div class="loggedin-list-load" v-else></div>
      </div>
    </PopupV2>
  </div>
</template>

<script>
export default {
  components: {},
  data: function () {
    return {
      userEmail: '',
      loginUserId: '',
      password: '',
      updatePassword1: '',
      updatePassword2: '',
      errorMessage: '',
      updatePassError: '',
      loading: false,
      loadText: '',
      useridDisable: false,
      userPasswordDisable: true,
      userDetails: null,
      showChangePass: false,
      isLoggedIn: false,
      logo: 'https://dsmapi.logistics.systems/logo/dsm.gif',
      defaultBranch: '',
      defaultBase: '',

      showUserList: false,
      loginDetailsList: [],

      companySearch: '',

      backSrc: '',

      showLoginBtn: false,

      loginBlockClass: 'login-btn-block hide',
      contBtnClass: 'btn',
      otherDetailsClass: 'other-details-block hide',

      companyList: [],
      branchList: [],
      baseList: [],

      selectedCompany: null,
      selectedBranch: null,
      selectedBase: null,

      selectedLoggedInUser: null,
    };
  },
  props: {},
  methods: {
    btnClick: async function (btn) {
      if (btn == 'continue') {
        if (this.userEmail == '') {
          this.errorMessage = 'Please enter your User Email';
          return;
        }

        this.loadText = 'Getting User Details';
        this.loading = true;
        const details = await this.$apiCallV2(`Login/VerifyUserLicense?email=${escape(this.userEmail)}`);
        this.loading = false;

        if (details.length > 0) {
          this.showLoginBtn = true;
          this.useridDisable = true;
          this.errorMessage = '';

          this.companyList = details;
          this.otherDetailsClass = 'other-details-block';

          this.companyList.forEach((c) => {
            c.showValue = `${c.co_refname} - ${c.co_name}`;
          });

          this.loginBlockClass = 'login-btn-block';
          this.contBtnClass = 'btn hide';

          this.$nextTick(() => {
            if (this.companyList.length == 1) {
              this.selectedCompany = this.companyList[0];
              this.companySelected(this.companyList[0]);
            } else {
              setTimeout(() => {
                this.$refs.companyDropdown.setFocus();
              }, 100);
            }
          });
        } else {
          this.errorMessage = 'Invalid user email';
        }
      } else if (btn == 'loginUser') {
        this.$router.push(`Home/u${this.selectedLoggedInUser['userKey']}`);
      } else if (btn == 'back') {
        this.errorMessage = '';
        this.useridDisable = false;

        this.selectedBranch = null;
        this.selectedBase = null;
        this.selectedCompany = null;

        this.loginBlockClass = 'login-btn-block hide';
        this.contBtnClass = 'btn';
        this.otherDetailsClass = 'other-details-block hide';

        this.password = '';

        this.branchList = [];
        this.baseList = [];

        this.showChangePass = false;
        this.isLoggedIn = false;
        this.showLoginBtn = false;
        this.companySearch = '';

        this.loginUserId = '';

        this.updatePassword1 = '';
        this.updatePassword2 = '';
        this.updatePassError = '';

        this.$nextTick(() => {
          this.$refs.userIdInput.setFocus();
        });
      } else {
        if (!this.selectedCompany) {
          this.errorMessage = 'Please select a company';
          this.$refs.companyDropdown.setFocus();
          return;
        }

        if (this.password.trim() != this.password) {
          this.errorMessage = 'Invalid User or Password';
          this.$refs.userPassInput.setFocus();
          return;
        }

        if (this.password.trim() == '') {
          this.errorMessage = 'Please enter your Password';
          this.$refs.userPassInput.setFocus();
          return;
        }

        this.errorMessage = '';

        this.loading = true;
        const EncodedPwd = btoa(this.password);
        const EncodedUserID = btoa(this.selectedCompany['LoginUserID']);
        const EncodedCompany = btoa(this.selectedCompany['ConfigCode']);

        const dataToPost = {
          UserPwd: EncodedPwd,
          UserID: EncodedUserID,
          Company: EncodedCompany,
        };

        const login = await this.$apiCallV2('Login/LoginUser', dataToPost);
        this.loading = false;

        if (login[0].Results == 0) {
          if (login[0].IsFirstTimeLogin == 1) {
            this.showChangePass = true;
            this.userPasswordDisable = true;

            setTimeout(() => {
              this.$refs.newPass1.setFocus();
            }, 50);
          } else {
            this.defaultBranch = login[0].BrCode ? login[0].BrCode.trim() : '';
            this.defaultBase = login[0].Base ? login[0].Base.trim() : '';
            this.userDetails.UserName = login[0].UserName ? login[0].UserName.trim() : '';

            this.loadText = 'Getting Branch and Base';
            this.loading = true;
            this.branchList = await this.$apiCallV2(
              `Login/GetBranchBase?userid=${this.selectedCompany.LoginUserID}&config=${this.selectedCompany.ConfigCode.trim()}&brCode=${login[0].BrCode}&cocode=${login[0].CoCode}`,
            );
            this.loading = false;

            this.isLoggedIn = true;
            this.userPasswordDisable = true;

            this.$nextTick(function () {
              if (this.defaultBranch) {
                const branch = this.branchList.filter((b) => {
                  return b.BrCode == this.defaultBranch;
                })[0];

                this.branchSelected(branch);
                this.selectedBranch = branch;
              } else {
                this.$refs.branchDropdown.setFocus();

                if (this.branchList.length == 1) {
                  this.branchSelected(this.branchList[0]);
                  this.selectedBranch = this.branchList[0];
                }
              }
            });
          }
        } else {
          this.errorMessage = login[0].ErrMsg;
          this.$refs.userPassInput.setFocus();
        }
      }
    },
    updateClick: async function () {
      this.updatePassError = '';
      const regex = /^[a-zA-Z0-9!?@ ]+$/;
      if (this.updatePassword1 == '' || this.updatePassword2 == '') {
        this.updatePassError = 'Please enter your new password';
      } else if (this.updatePassword1 !== this.updatePassword2) {
        this.updatePassError = 'Your new password did not match';
      } else if (this.updatePassword1.trim() == '' || this.updatePassword2.trim() == '') {
        this.updatePassError = 'Password cannot consist of spaces only';
      } else if (
        this.updatePassword1.trim() !== this.updatePassword1 ||
        this.updatePassword2.trim() !== this.updatePassword2
      ) {
        this.updatePassError = 'Password cannot have leading or trailing spaces';
      } else if (this.updatePassword1.trim().length > 20 || this.updatePassword2.trim().length > 20) {
        this.updatePassError = 'Password cannot exceed 20 characters';
      } else if (!regex.test(this.updatePassword1.trim()) || !regex.test(this.updatePassword2.trim())) {
        this.updatePassError = 'Password can only contain letters, numbers, spaces and the symbols !, @, ?';
      } else {
        this.loadText = 'Updating password';
        this.loading = true;

        const EncodedPwd = btoa(this.updatePassword2);
        const EncodedUserID = btoa(this.loginUserId);
        const EncodedCompany = btoa(this.selectedCompany['ConfigCode']);

        const dataToPost = {
          UserPwd: EncodedPwd,
          UserID: EncodedUserID,
          Company: EncodedCompany,
        };
        const update = await this.$apiCallV2('Login/ResetPassword', dataToPost);
        this.loading = false;

        if (update[0].Results == 0) {
          this.$showAlert(
            'success',
            'Password Updated',
            `<div>You have successfully update your password!</div>
                  <div>Please re-login using your new password</div>`,
          );
          // alert('You have succesfully update your password.\nPlease re-login using the new password');
          this.showChangePass = false;
          this.userPasswordDisable = false;
          this.password = '';

          setTimeout(() => {
            this.$refs.userPassInput.setFocus();
          }, 10);
        } else {
          this.updatePassError = update[0].ErrMsg;
        }
      }
    },
    nextClick: async function () {
      let userIndex = 0;
      const allUserKeys = this.getAllUserKeys();
      if (allUserKeys.length > 0) {
        const maxIndex = Math.max(...allUserKeys.map((a) => Number(a.match(/\d/g).join(''))));
        userIndex = maxIndex + 1;
      }

      const savedUser = {
        Email: this.userEmail,
        CoCode: this.userDetails.CoCode,
        ConfigCode: this.userDetails.ConfigCode.trim(),
        LoginUserID: this.userDetails.LoginUserID,
        LoginTime: new Date(),
        CoLogo: this.userDetails.co_logo,
        CoName: this.userDetails.co_name,
        CoRefname: this.userDetails.co_refname,
        Expirydate: this.userDetails.expirydate,
        Forceversionupgrade: this.userDetails.forceversionupgrade,
        ShowValue: this.userDetails.showValue,
        Staylogondays: this.userDetails.staylogondays,
        Branch: this.selectedBranch,
        BaseName: this.selectedBase['baseKey'],
        CoFooterFin: this.userDetails.CoFooterFin,
        CoFooterOpr: this.userDetails.CoFooterOpr,
        CoHeaderFin: this.userDetails.CoHeaderFin,
        CoHeaderOpr: this.userDetails.CoHeaderOpr,
        UserName: this.userDetails.UserName,
        favicon: this.userDetails.favicon || this.userDetails.co_logo,
      };

      const loggedIn = await this.$apiCallV2('/Login/SaveLoginDetails', savedUser);

      localStorage.setItem(`u${userIndex}`, loggedIn['hash']);
      this.$store.commit('updateLoggedInAccounts', {
        userKey: `u${userIndex}`,
        user: `${savedUser['LoginUserID']} - ${savedUser['CoRefname']}`,
      });
      this.$bus.$emit('userLoggedIn');

      let landingPageURL = `Home/u${userIndex}`;
      if (loggedIn.landingPage?.startsWith('/')) {
        landingPageURL += loggedIn.landingPage;
      } else {
        landingPageURL += `/${loggedIn.landingPage ?? ''}`;
      }

      this.$router.push(landingPageURL);
    },
    companySelected: function (val) {
      this.baseList = [];
      this.branchList = [];

      this.selectedBranch = null;
      this.selectedBase = null;

      this.userDetails = val;

      this.userPasswordDisable = false;

      this.loginUserId = val.LoginUserID;
      this.logo = val.co_logo;
    },
    branchSelected: function (val) {
      this.baseList = [];
      this.selectedBase = null;

      const allBases = val.BaseList.split(',');
      allBases.forEach((b) => {
        this.baseList.push({ baseKey: b });
      });
    },
    baseSelected: function (val) {
      this.selectedBase = val;
    },
    inputEnter: function (e, item) {
      if (e.key == 'Enter') {
        this.btnClick(item);
      }
    },

    getAllUserKeys: function () {
      const localKeys = Object.keys(localStorage);
      return localKeys.filter((l) => l.match(/^u[0-9]/));
    },
    loggedInAccountClicked: async function (key) {
      const details = await this.$apiCallV2(`/Login/GetDetails?key=${localStorage.getItem(key)}`);
      if (!details) {
        const alertResponse = await this.$showAlert(
          'error',
          'Login Details Not Found',
          `<div>Click OK to have the page refreshed</div>`,
          [{ 'text': 'OK' }]
        );
        if (alertResponse === 'OK') {
          this.showUserList = false;
          await this.loadLoginList();
        }
        return;
      }
      let landingPage = details['LandingPage'];
      if (!landingPage.startsWith('/')) {
        landingPage = `/${landingPage}`;
      }
      this.$router.push(`/Home/${key}${landingPage}`);
      this.$bus.$emit('userLoggedIn');
    },
    loggedinListLogoutClicked: async function (e, key, data) {
      e.stopPropagation();
      const confirmLogout = await this.$showAlert(
        'warning',
        'Logout Account',
        `Are you sure you want to logout from account with below details?<br>User ID: <b>${data['LoginUserId']}</b><br>Company: <b>${data['CoName']}</b>`,
        [
          { text: 'Logout', color: 'red', textColor: 'white' },
          { text: 'Cancel', color: 'gray', textColor: 'white' },
        ],
      );

      if (confirmLogout == 'Logout') {
        await this.$apiCallV2(`/Login/RemoveLoginDetails?key=${localStorage.getItem(key)}`);

        localStorage.removeItem(key);

        const listIndex = this.loginDetailsList.findIndex((l) => JSON.stringify(l) == JSON.stringify(data));
        if (listIndex >= 0) {
          this.loginDetailsList.splice(listIndex, 1);
        }

        if (this.loginDetailsList.length == 0) {
          this.showUserList = false;
        }
      }
    },
    loadLoginList: async function() {
      const users = this.getAllUserKeys();
      if (users.length > 0) {
        this.loginDetailsList = [];

        for (const u of users) {
          const details = await this.$apiCallV2(`/Login/GetDetails?key=${localStorage.getItem(u)}`);
          if (!details) {
            localStorage.removeItem(u);
          } else {
            details['key'] = u;
            this.loginDetailsList.push(details);
          }
        }

        if (this.getAllUserKeys().length == 0) {
          this.showUserList = false;
          this.$refs.userIdInput.setFocus();
        } else {
          this.showUserList = true;
        }
      } else {
        this.$nextTick(function () {
          this.$refs.userIdInput.setFocus();
        });
      }
    }
  },
  async mounted() {
    const rand = Math.random() * 3;
    this.backSrc = `https://dsmapi.logistics.systems/dsm6gicons/LoginBackgrounds/BImg${Math.ceil(rand)}.jpg`;

    await this.loadLoginList();
  },
  watch: {
    selectedCompany: function (val) {
      if (!val) {
        this.password = '';
        this.loginUserId = '';
      } else {
        setTimeout(() => {
          this.$refs.userPassInput.setFocus();
        }, 100);
      }
    },
    selectedBranch: function (val) {
      if (val) {
        setTimeout(() => {
          this.$refs.baseDropdown.setFocus();
          if (this.baseList.length == 1) {
            this.baseSelected(this.baseList[0]);
            this.selectedBase = this.baseList[0];
          }
        }, 100);
      }
    },
    selectedBase: function (val) {
      if (val) {
        setTimeout(() => {
          this.$refs.nextBtn.focus();
        }, 100);
      }
    },
    selectedLoggedInUser: function () {
      this.errorMessage = '';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.login-main {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60%;
  font-size: 12px;

  > .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 5px;
    justify-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border-radius: 5px;
    padding: 5px;

    > img {
      height: 20px;
    }
  }
}

.logo {
  height: 100px;
  margin: 50px 0 20px 0;
}

.other-details-block {
  position: relative;
  width: 100%;
}

.btn-block {
  position: relative;
  margin-top: 10px;
  // background-color: yellow;
  display: flex;
  justify-content: center;
  transition: 0.3s;
}

.login-btn-block {
  position: absolute;
}

.hide {
  height: 0;
  opacity: 0;
  visibility: hidden;
}

.btn {
  width: 150px;
  margin: 0 10px;
}

.error {
  color: red;
}

.change-password {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}

.background-img {
  position: absolute;
  opacity: 0.75;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: -999;
}

.login-container {
  width: 100%;
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  margin-top: 10px;
  border-radius: 5px;

  .user-id {
    margin-top: -3px;
    margin-bottom: 10px;
    text-align: center;
  }

  > .logged-in-list {
    margin-top: 10px;
  }
}

.loggedin-list-container {
  overflow: hidden !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  > .logged-in-container-body {
    overflow: auto;
    height: 100%;
    width: 100%;

    > .loggedin-list-content {
      border: 1px solid gray;
      margin: 5px 5px 0 5px;
      padding: 5px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: outline 0.1s;

      &:hover {
        background-color: rgba(200, 200, 200, 0.5);
      }

      > .loggedin-list-details {
        width: 100%;
        text-align: left;

        > .loggedin-list-row {
          display: flex;
          align-items: center;

          > :first-child {
            min-width: 90px;
            font-weight: bold;
          }

          > :nth-child(2) {
            padding: 0 5px;
          }
        }
      }

      > button {
        margin-left: 5px;
      }
    }
  }

  > .loggedin-list-load {
    height: 20px;
    width: 20px;
    border-style: solid;
    border-width: 2px;
    border-color: transparent gray gray gray;
    border-radius: 100%;
    animation: loggedinSpin 0.75s ease-in-out infinite;
  }
}
</style>

<style>
@keyframes loggedinSpin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
